export const getFirstErrorMsg = (obj: unknown): string | undefined => {
  if (!obj || typeof obj !== 'object') return undefined;

  for (const key in obj as Record<string, unknown>) {
    const val = (obj as Record<string, unknown>)[key];
    
    if (val && typeof val === 'object' && 'message' in val && typeof (val as { message?: unknown }).message === 'string') {
      return (val as { message: string }).message;
    }
    
    if (val && typeof val === 'object') {
      const msg = getFirstErrorMsg(val);
      if (msg) return msg;
    }
  }
  return undefined;
};
